// extracted by mini-css-extract-plugin
module.exports = {"jobsSectionContainer":"JobsSection_jobsSectionContainer__iIxlH","jobsSectionTitle":"JobsSection_jobsSectionTitle__7TuK5","jobsGrid":"JobsSection_jobsGrid__Q0yEJ"};